<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">

            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn mt-3"
                              svg-classes="h-5 w-5 hover:text-primary cursor-pointer" @click="updateQuestion">
                </feather-icon>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                <feather-icon icon="TrashIcon" class="action-err icon-btn mt-3"
                              svg-classes="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteQuestion">
                </feather-icon>
            </vx-tooltip>
        </div>
    </div>
</template>

<script>
export default {
    name: "CellRendererActionQuestion",
    data() {
        return {}
    },
    methods: {
        updateQuestion() {
            this.$store.commit('UPDATE_QUESTION', this.params.data)
        },

        confirmDeleteQuestion() {
            this.$vs.dialog({
                type:'confirm',
                color:'danger',
                title: 'Xác nhận xoá',
                text:`Bạn có chắc là muốn xoá câu hỏi này không?`,
                accept: this.deleteQuestion,
                acceptText:'Xoá',
                cancelText:'Huỷ',
            })
        },

        deleteQuestion() {
            this.$vs.loading();
            this.$crm.post(`/school-question-quiz/delete/${this.params.data.id}`).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Xóa câu hỏi thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success',
                });
                this.$store.commit('DELETE_QUESTION', true)
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        }
    }
}
</script>

<style scoped>

</style>
